import React, { useEffect } from 'react';
import styled from 'styled-components';
import { colors } from '../styles/colors';
import RSVPForm from './rsvp/RSVPForm';
import Footer from './Footer';
import Navigation from './Navigation';

const PageContainer = styled.div`
  min-height: 100vh;
  background-color: ${colors.primary.lightTan};
  padding: 2rem 0 0 0; /* Remove bottom padding to eliminate gap */
  position: relative;
`;

const BackgroundImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-image: url('/images/cheers-2.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // background: rgba(0, 0, 0, 0.3);
    z-index: 2;
  }
`;

const RSVPOverlay = styled.div`
  position: absolute;
  top: 60vh;
  left: 25%;
  transform: translate(-50%, -50%) rotate(-12deg);
  z-index: 5;
  font-family: 'saint-andrews-queen', serif;
  font-size: 8rem;
  color: ${colors.neutral.cream};
  pointer-events: none;
  user-select: none;
  
  @media (max-width: 1200px) {
    font-size: 6rem;
    top: 50vh;
    left: 30%;
  }
  
  @media (max-width: 768px) {
    font-size: 4rem;
    top: 50vh;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-5deg);
  }
  
  @media (max-width: 480px) {
    font-size: 4rem;
    top: 45vh;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-5deg);
  }
`;

const HeroMountainDivider = styled.div`
  --divider-height: clamp(140px, 19.45vw, 360px);

  position: absolute;
  top: calc(100vh - var(--divider-height) + 1px);
  left: 0;
  width: 100%;
  height: var(--divider-height);
  z-index: 2;
  pointer-events: none;
  background-color: ${colors.primary.lightTan};
  mask-image: url('/images/mountains/mountain-soft-top.svg');
  mask-size: 100% 100%;
  mask-repeat: no-repeat;
  mask-position: center bottom;
  -webkit-mask-image: url('/images/mountains/mountain-soft-top.svg');
  -webkit-mask-size: 100% 100%;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center bottom;

  @media (max-width: 768px) {
    --divider-height: clamp(90px, 19.45vw, 150px);
  }

  @media (max-width: 480px) {
    --divider-height: clamp(70px, 19.45vw, 110px);
  }
`;


const ContentContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  position: relative;
  z-index: 3;
  margin-top: 100vh;
  min-height: 400px;
  margin-bottom: 0; /* Ensure no bottom margin */

  @media (max-width: 768px) {
    min-height: 450px;
  }

  @media (max-width: 480px) {
    min-height: 350px;
  }
`;

const RSVPPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageContainer>
      <BackgroundImage />
      <HeroMountainDivider />
      
      <RSVPOverlay>RSV P</RSVPOverlay>
      
      <Navigation 
        textColor={colors.neutral.darkBrown}
        logoPath="/images/agave-full-logo-brn.png"
      />
      
      <ContentContainer>
        <RSVPForm />
      </ContentContainer>
      <Footer backgroundColor={colors.primary.lightTan} />
    </PageContainer>
  );
};

export default RSVPPage; 